import { IfGateAndOr } from '../../enums/if-gate/if-gate-and-or.enum';
import { IfRule } from '../../interfaces/if-gate/if-rules';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';
import { Guid } from '../guid';

/**
 * A single conditional branch within an IfGate. Contains an ordered list of rules
 * combined by `andOr` logic. When the group evaluates to true, the record is routed
 * to `successMappingID`. Can contain nested `IfRuleGroup` objects for complex logic.
 */
export class IfRuleGroup extends DestinationTaskConfigBase {
	/** Unique identifier for this rule group. */
	id = Guid();

	/**
	 * The individual condition rules (or nested IfRuleGroup objects) for this branch.
	 * Evaluated using `andOr` logic to determine if the group passes.
	 */
	ruleGroup: (IfRule | IfRuleGroup)[] = [];

	/**
	 * How rules within this group are combined.
	 * '&&' = ALL rules must pass. '||' = ANY rule can pass.
	 * @default IfGateAndOr.And ('&&')
	 */
	andOr = IfGateAndOr.And;

	constructor(init?: Partial<IfRuleGroup>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
		if (!this.id) {
			this.id = Guid();
		}
	}

	override GetDestinationTasks(): string[] {
		return [this.successMappingID];
	}
}
